module.exports = "<div class=\"status-info\">\n    <span class=\"capitalize\">{{ client.status| lowercase }}</span>\n    on {{ client.statusDate | timeFilter: \"long\" }}\n    <span *ngIf=\"client.statusSource === 'BY_USER'\">by you</span>\n    <span *ngIf=\"client.statusSource === 'BY_CLIENT'\">by client</span>\n    <span *ngIf=\"client.statusSource === 'CONTACT_FORM'\">via Contact Form</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/client/client-subscribe-info/client-subscribe-info.html
// module id = ./web/modern/components/client/client-subscribe-info/client-subscribe-info.html
// module chunks = 0